export default "__VITE_ASSET__1s9LcaQr__"